import { createStandardAction } from 'typesafe-actions';

const CHANGE_RULES = "rules/CHANGE_RULES";
const REQUEST_CHANGE_RULES = "rules/REQUEST_CHANGE_RULES";
const SET_OPACITY = "faq/SET_OPACITY";

export const changeRules = createStandardAction(CHANGE_RULES)<number>();
export const requestChangeRules = createStandardAction(REQUEST_CHANGE_RULES)<
  number
>();
export const setOpacity = createStandardAction(SET_OPACITY)<boolean>();



// WEBPACK FOOTER //
// ./src/store/modules/rules/actions.ts